module.exports = __webpack_public_path__ + "img/1f61d.4146c06.svg";